import React, { useEffect, useState } from 'react';
import Header from '../components/Header'
import {
	Box,
	HStack,
	Text,
	Heading,
	Tabs, TabList, TabPanels, Tab, TabPanel,
} from '@chakra-ui/react'
import PageLoader from '../components/Loader/PageLoader';

import {

	ChannelChart,
	MessageDeliverd,
	CustomerType,
	CustomerWiseMessageCount,
	CustomerWiseRenevuCount,
	DailyMsgCount,
	CountryWiseMsg,
	CountryWiseCost

} from './chart/dashboard-chart';

import { fetchWrapper } from '../helpers';
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';
import LiveMonitor from './Monitor/LiveMonitor';
import EventsMonitor from './Monitor/EventsMonitor';
import Infrastructure from './Monitor/Infrastructure';

const Dashboard = () => {
	const [data, setData] = useState([]);
	const [loading, setloading] = useState(false);


	useEffect(() => {
		LoadData();

	}, [])

	const LoadData = async () => {
		setloading(true)
		const url = `${process.env.REACT_APP_API_URL}/dashboard`;
		const data = await fetchWrapper.get(url)
		setData(data.data)
		setloading(false)
	}
	const roundMe = (num) => {

		if (num) {
			return num.toFixed(4)
		}

	}
	return (
		<>
			<PageLoader isLoading={loading} />
			<Header />
			<BoxWrapper>
				<Tabs variant="line" colorScheme="blue" isLazy>
					<TabList mb="20px">
						<Tab fontWeight="600">Overview</Tab>
						<Tab fontWeight="600">Message Monitor</Tab>
						<Tab fontWeight="600">Events Monitor</Tab>
						<Tab fontWeight="600">Infrastructure</Tab>
					</TabList>
					<TabPanels>
						{/* ── Tab 1: Overview (existing platform analytics) ── */}
						<TabPanel p={0}>
							<Box>
								<Box mb="28px">
									<Text fontSize="22px" fontWeight="700" color="#111827" my="0px" fontFamily="'Open Sans', sans-serif" letterSpacing="-0.02em">Dashboard</Text>
								</Box>

								<Box className="analytics_panel_section">
									<HStack mb="30px">
										<Box className="analytics_box_section">
											<Heading>{data?.customerCount}</Heading>
											<Text>Total Customers </Text>
										</Box>

										<Box className="analytics_box_section">
											<Heading>{data?.MessageVolumeCount}</Heading>
											<Text>Total Message Volume </Text>
										</Box>

										<Box className="analytics_box_section">
											<Heading> {roundMe(data?.roundedTotalCR) || 0}</Heading>
											<Text>Total Top-up <span>(Till Date)</span></Text>
										</Box>

										<Box className="analytics_box_section">
											<Heading> {roundMe(data?.roundedTotalDR) || 0}</Heading>
											<Text>Total Used <span>(Till Date)</span></Text>
										</Box>

										<Box className="analytics_box_section">
											<Heading> {roundMe(data?.totalBalance)}</Heading>
											<Text>Current Balance</Text>
										</Box>
									</HStack>

									<HStack w="100%">
										<Box w="33%" className="chart_box" >
											<ChannelChart datalist={data} />
										</Box>
										<Box w="33%" className="chart_box">
											<MessageDeliverd datalist={data} />
										</Box>
										<Box w="33%" className="chart_box">
											<CustomerType datalist={data} />
										</Box>
									</HStack>

									<Box className="chart_box">
										<CustomerWiseMessageCount datalist={data} />
									</Box>

									<Box className="chart_box">
										<CustomerWiseRenevuCount datalist={data} />
									</Box>

									<Box className="chart_box">
										<DailyMsgCount datalist={data} />
									</Box>

									<Box className="chart_box">
										<CountryWiseMsg datalist={data} />
									</Box>

									<Box className="chart_box">
										<CountryWiseCost datalist={data} />
									</Box>
								</Box>
							</Box>
						</TabPanel>

						{/* ── Tab 2: Live Monitor (FEAT-MONITOR-001) ── */}
						<TabPanel p={0}>
							<LiveMonitor />
						</TabPanel>

						{/* ── Tab 3: Events Monitor (FEAT-MONITOR-001) ── */}
						<TabPanel p={0}>
							<EventsMonitor />
						</TabPanel>

						{/* ── Tab 4: Infrastructure (FEAT-MONITOR-001) ── */}
						<TabPanel p={0}>
							<Infrastructure />
						</TabPanel>
					</TabPanels>
				</Tabs>
			</BoxWrapper>
		</>
	)
}

export default Dashboard
